export const MUNICIPAL_PROPERTY_GHG_DERIVED_ID_PREFIX = "municipal-property-ghg:";
